import React from 'react'

const SvgVolumeFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 16.009l4.537 3.934c.417.138.764.118 1.041-.058.278-.176.419-.476.422-.901l.004-13.678c.017-.576-.124-.953-.422-1.13-.298-.177-.645-.207-1.04-.09L6 8.009H4c-1.33.007-1.996.674-1.996 2 0 1.765-.004 3.436-.004 4 0 1.325.667 1.996 2 2.013l2-.013zm11.398 3.797a1 1 0 001.4-.19c2.068-2.71 3.206-4.094 3.206-7.581 0-3.486-1.137-4.924-3.202-7.632a1 1 0 10-1.59 1.213c1.8 2.36 2.792 3.368 2.792 6.419 0 3.052-.992 4.006-2.795 6.37a.997.997 0 00.189 1.4zm-2.674-3.29c.44.336.816.326 1.402-.187 1.02-.895 1.878-2.532 1.878-4.292 0-1.76-.73-3.238-1.878-4.325-.345-.4-.96-.497-1.399-.162-.439.336-.546 1.095-.189 1.402 1.113.956 1.466 2.083 1.466 3.085 0 1-.319 2-1.468 3.079-.146.137-.205.394-.205.606a1 1 0 00.393.795v-.001z'
    />
  </svg>
)

export default SvgVolumeFilled
